<template>

    <v-section>
        <h3>Key Features</h3>
        <div class="features">
            <div v-for="feature in features" :key="feature.name" class="feature">
                <div class="icon">
                    <i :class="feature.icon"></i>
                </div>
                <div>
                    <div class="name">{{ feature.name }}</div>
                    <div class="desc">{{ feature.desc }}</div>
                </div>
            </div>
        </div>
    </v-section>

</template>

<style scoped lang="scss">

    .features {
        display: grid;
        gap: 30px;
        grid-template-columns: repeat(3, 1fr);
        @media (max-width: map-get($grid-breakpoints, 'md')) {
            grid-template-columns: repeat(2, 1fr);
        }
        @media (max-width: map-get($grid-breakpoints, 'sm')) {
            grid-template-columns: repeat(1, 1fr);
        }
    }

    .feature {
        align-items: top;
        display: flex;
        text-align: left;
        .name {
            @include font-semibold(16px);
            line-height: 1.6em;
            margin-bottom: 2px;
        }
        .desc {
            @include font-medium(15px);
            line-height: 1.6em;
        }
        .icon {
            align-items: center;
            background: $color-primary;
            border-radius: 5px;
            display: flex;
            flex-shrink: 0;
            height: 40px;
            justify-content: center;
            margin-right: 15px;
            width: 40px;
            i {
                color: #fff;
                font-size: 16px;
            }
        }
    }

</style>

<script>

export default {

    data() {
        return {
            features: [
                {
                    icon: 'fas fa-id-card',
                    name: 'Customer Activity',
                    desc: 'See all of your customers in one place, with traits, event history, page history, charge history, and more.',
                },
                {
                    icon: 'fas fa-fire',
                    name: 'Event Timelines',
                    desc: 'A complete timeline of every action your customers take in your app, along with properties for each one.',
                },
                {
                    icon: 'fas fa-paper-plane',
                    name: 'Automations',
                    desc: 'Create automations based on customer behavior to send emails, Slack and Discord alerts, SMS, and more.',
                },
                {
                    icon: 'fas fa-envelope',
                    name: 'Broadcasts',
                    desc: 'Send one-off announcements to all of your customers or a specific segment.',
                },
                {
                    icon: 'fas fa-chart-pie',
                    name: 'Segmenting',
                    desc: 'Segment your customers using any combination of rules based on traits, events, tags, charges, and more.',
                },
                {
                    icon: 'fas fa-shapes',
                    name: 'Visual Email Builder',
                    desc: 'A comprehensive and easy-to-use email builder, built from scratch to make composing emails a breeze.',
                },
                {
                    icon: 'fas fa-pause-circle',
                    name: 'Smart Sending',
                    desc: 'Specify the number of days to wait before messaging the same customer again.',
                },
                {
                    icon: 'fas fa-ban',
                    name: 'Unsubscribe Groups',
                    desc: 'Customers can unsubscribe from broadcasts, automations, or all CrowdPower emails.',
                },
                {
                    icon: 'fas fa-bell',
                    name: 'Web Push Notifications',
                    desc: 'Send web push notifications as part of any automation or broadcast.',
                },
                {
                    icon: 'fas fa-plug',
                    name: 'Native Integrations',
                    desc: 'Integrate with Discord, Slack, Stripe, Twilio SMS, and more.',
                },
                {
                    icon: 'fas fa-users',
                    name: 'Unlimited Members',
                    desc: 'Invite all of your team members to your projects with no extra charge.',
                },
                {
                    icon: 'fas fa-comments',
                    name: '24/7 Support',
                    desc: 'All customers get support over email, chat, and Slack Connect.',
                },
            ],
        }
    },

}

</script>